
import { Separator } from "../../ui/separator";

interface FeatureItem {
  title: string;
  description: string;
}

interface MediaPlanningFeaturesProps {
  features: FeatureItem[];
}

const MediaPlanningFeatures = ({ features }: MediaPlanningFeaturesProps) => {
  return (
    <>
      <Separator className="my-12 hidden md:block" />
      
      <div className="md:grid md:grid-cols-3 md:gap-8 mt-6 md:mt-12">
        {features.map((feature, index) => (
          <div key={index} className="flex flex-col">
            <div className="py-2 md:py-0">
              <h3 className="text-base md:text-lg font-semibold text-primary mb-0.5">{feature.title}</h3>
              <p className="text-sm text-secondary">{feature.description}</p>
            </div>
            {index < features.length - 1 && <hr className="border-t border-gray-200 md:hidden my-1" />}
          </div>
        ))}
      </div>
    </>
  );
};

export default MediaPlanningFeatures;
